export const tamper = {
    /**
    * --------------------------------------------------------------------------
    * Tamper Language Lines
    * --------------------------------------------------------------------------
    *
    * The following language lines are used by Tamper management system to build 
    * form, grid and other related places where tample related labels required.
    * You are free to change them to anything
    * you want to customize your views to better match your application.
    * 
    */
    en: {
        tamper:"Tamper",
        tamper_management:"Tamper Management",
        tamper_code:" Code",
        tamper_code_name:" Code Name",
        tamper_description:" Description",
        add_tamper:"Add Tamper",
        edit_tamper:"Edit Tamper",
        tamper_information:"Tamper Information",
        tamper_status:"Status",
        add:{
            success: 'Tamper added successfully',
            error: 'Unable to add tamper. Please try again',
        },
        get:{
            error: 'Unable to find the data. Please try again'
        },
        edit:{
            success: 'Tamper updated successfully',
            error: 'Unable to update tamper. Please try again',
        }
    },

    ar: {
        tamper:"تلاعب \ عبث",
        tamper_management:"إدارة التلاعب",
        tamper_code:"الشفرة",
        tamper_code_name:"اسم الرمز",
        tamper_description:"الوصف",
        add_tamper:"أضف تلاعب",
        edit_tamper:"تحرير التلاعب",
        tamper_information:"معلومات التلاعب",
        tamper_status:"الحالة",
        add:{
            success: 'تمت إضافة التلاعب بنجاح',
            error: 'غير قادر على إضافة التلاعب. حاول مرة اخرى',
        },
        get:{
            error: 'تعذر العثور على البيانات. حاول مرة اخرى'
        },
        edit:{
            success: 'تم تحديث التلاعب بنجاح',
            error: 'تعذر تحديث التلاعب. حاول مرة اخرى',
        }
    }
}